export default "__VITE_ASSET__c6dbaf79__"